export { default } from './Container';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Container/index.js
// module id = 791
// module chunks = 121